import { CSSProperties, useState } from "react";
import { TransformComponent, TransformWrapper } from "react-zoom-pan-pinch";
import { Css } from "~generated/css";

type DraggableImageWrapperProps = {
  draggable: boolean;
  children: React.ReactNode;
  initialScale?: number;
  contentStyle?: CSSProperties;
  limitToBounds?: boolean;
};

/**
 * A draggable image wrapper component that displays an image at full size
 * and allows users to pan around to view different parts.
 * Uses react-zoom-pan-pinch for smooth pan/zoom interactions on mobile.
 */
export function DraggableImageWrapper(props: DraggableImageWrapperProps) {
  const { draggable, children, initialScale = 1, contentStyle = Css.w100.h100.$, limitToBounds = true } = props;
  const [isPanning, setIsPanning] = useState(false);
  if (!draggable) {
    return <>{children}</>;
  }

  return (
    <TransformWrapper
      initialScale={initialScale}
      limitToBounds={limitToBounds}
      centerOnInit
      doubleClick={{ mode: "toggle" }}
      onPanningStart={() => setIsPanning(true)}
      onPanningStop={() => setIsPanning(false)}
    >
      <TransformComponent
        wrapperStyle={Css.w100.h100.add("cursor", "grab").if(isPanning).add("cursor", "grabbing").$}
        contentStyle={contentStyle}
      >
        {children}
      </TransformComponent>
    </TransformWrapper>
  );
}
